module.exports = __webpack_public_path__ + "amex-icon@3x.png?449e63014acfaa26697b6add8922777e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amex-icon@3x.png
// module id = 1045
// module chunks = 0